var map = {
	"./VID-20230420-WA0029.mp4": 6386,
	"./VID-20230426-WA0025.mp4": 8481,
	"./WhatsApp Video 2022-05-17 at 12.27.33 PM.mp4": 40808,
	"./WhatsApp Video 2022-05-17 at 12.44.53 PM.mp4": 37601,
	"./light fedility.mp4": 12716,
	"./save soil story.mp4": 81085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88285;